import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {ElementTestId} from '@Tests/tests.types';
import {useAppSelector} from '@/hooks';
import {getIsCurrentPagePlaying, getPagePlaybackIcon} from '@Components/poster-editor/poster-editor-reducer';
import {noop} from '@Utils/general.util';

interface IconPlayPauseProps {
  className?: string;
  size?: IconSize;
  shape?: IconShape;
  type?: IconType;
  onClick?: (shouldPlay: boolean) => void;
  hasMarginRight?: boolean;
}

export function IconPlayPause({
  className = '',
  size = IconSize.SIZE_ICON_20,
  shape = IconShape.CIRCLE,
  onClick = noop,
  type = IconType.SHADOW,
  hasMarginRight = true,
}: IconPlayPauseProps): ReactElement {
  const currentPageId = useAppSelector((state) => state.posterEditor.currentPageId);
  const isPlaying = useAppSelector(getIsCurrentPagePlaying);
  const icon = useAppSelector((state) => getPagePlaybackIcon(state, currentPageId));

  return (
    <Icon
      onClick={(): void => {
        onClick(!isPlaying);
      }}
      className={`${hasMarginRight ? 'spacing-m-r-2' : ''} ${className}`}
      icon={icon}
      size={size}
      shape={shape}
      type={type}
      data-testid={ElementTestId.POSTER_EDITOR_WEB_BOTTOM_BAR_PLAY_PAUSE_BUTTON}
    />
  );
}
